<template>
    <div class="load-mask-parent">
        <div :class="loadMask"></div>
        <canvas ref="my-canvas"></canvas>
    </div>
</template>
<script>

import CChart from "./cchart/CChart";
import DiffChart from "./cchart/Template/DiffChart";
import UrlResolver from "../services/UrlResolver";
import ValueChecker from "../services/ValueChecker";

export default {
    components: {},
    props: {
        config: {
            Type: Object
        },
        eventBus: {
            Type: Object,
        },
        moduleConfig: {
            Type: Object
        },
        routeName: {
            Type: String,
            require: true,
        },
    },
    data() {
        return {
            cChart: null,
            firstLoading: false,
            loadMask: '',
            events: [],
            moduleIndex: null,
            resizeCallback: null,
            state: {},
        }
    },
    mounted() {
        this.$root.$once('CustomModule:ready', (customModuleEventName, moduleIndex) => {
            this.events.push('CustomModule:ready');
            this.events.push(customModuleEventName);
            this.moduleIndex = moduleIndex;
            this.$root.$on(customModuleEventName, (moduleConfig, state) => {
                this.mountEvents();
                this.init();
            });
        });
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    methods: {
        chart() {
            this.firstLoading = true;
            this.loadMask = 'lmask';
            let data = this.state;

            return this.$http.get(this.routeName + '/chart-' + this.config.index, {params: data}).then(response => {
                this.loadMask = '';
                this.renderChart(response.data.labels, response.data.items);
            });
        },
        init() {
        },
        mountEvents() {
            this.resizeCallback = () => {
                setTimeout(() => {
                    let c = this.$refs['my-canvas'];
                    c.width = c.parentElement.clientWidth;
                    c.height = c.parentElement.clientHeight;
                }, 1000);
            };

            window.addEventListener('resize', this.resizeCallback);
            this.eventBus.$on('Dashboard:toggleMenu', this.resizeCallback);
            this.events.push('Dashboard:toggleMenu');

            this.eventBus.$on(`${this.moduleIndex}-ToggleFilterPanel:filter-change`, (filterName, filterValue, filter, filters, serializedFilters) => {
                this.state = Object.assign(this.state, serializedFilters);
                this.chart();
            });
            this.events.push(`${this.moduleIndex}-ToggleFilterPanel:filter-change`);
        },
        renderChart(labels, items) {
            let c = this.$refs['my-canvas'];

            let records = [];
            //max scale
            let height = 0;
            let max = 0;

            items.forEach((v, index) => {
                height += 30;
                records.push({
                    label: v.label,
                    all: v.extraData.total,
                    contains: v.extraData.contains,
                    items: v.data,
                    shopId: v.extraData.shopId,
                    sellerId: v.extraData.sellerId,
                    group: v.extraData.group
                });

                if (max < v.extraData.contains) {
                    max = v.extraData.contains;
                }
            });

            height += 60;
            c.height = height;

            if (!ValueChecker.isUndefinedOrNull(this.cChart)) {
                this.cChart.clear();
                delete this.cChart;
            }

            this.cChart = new CChart(c, new DiffChart(), this.eventBus);
            let chartConfig = {
                callback: (data, group)  => {
                    if (this.config.embeddedModules.length === 0) {
                        return;
                    }

                    let embeddedModule = this.config.embeddedModules[0];
                    data['group'] = group;
                    let url = UrlResolver.resolveUrl(embeddedModule.url, data, embeddedModule.query, this.state);
                    window.open(url);
                },
                labels: labels,
                max: max,
            };
            this.cChart.setConfig(chartConfig);
            this.cChart.setData(records);
            this.cChart.render();
        },
        unmountEvents() {
            window.removeEventListener('resize', this.resizeCallback);

            this.events.forEach(e => {
                this.eventBus.$off(e);
            });
        }
    },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CanvasChart.vue?4a49d134